import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Posts } from "./MindSets";
import { get, remove } from '../../services/storage.service';
import axios from "axios";

import { useIonViewWillEnter } from "@ionic/react";

import { logOutOutline, chevronBackOutline } from 'ionicons/icons';

import FooterComponent from "../FooterComponent";
import LoginCheck from "../LoginCheck";
import './PostsContainer.css';

import {
  IonContent,
  IonHeader,
  IonPage,
  IonToolbar,
  IonSegment,
  IonLabel,
  IonSegmentButton,
  IonButton,
  IonText,
  IonGrid,
  IonLoading,
  IonRow,
  IonCol,
  IonIcon
} from "@ionic/react";

export default function MindSetContainer() {
  let { catid } = useParams<any>();
  const [posts, setPosts] = useState<any[]>([]);
  const [posttype, setPostType] = useState<string>('_field_school-name');
  const [page, setPage] = useState<number>(0);
  const [totPages, setTotPages] = useState<number>(0);//1
  const [title, setTitle] = useState<string>();
  const history = useHistory();
  const [showLoading, setShowLoading] = useState(false);

  useIonViewWillEnter(() => {
    console.log('--call the page again--');
  });
  
  useEffect(() => {
    const pageTitle = ['Elementary','Middle','Secondary'];
    
    function getCategoryName(id:any) {
      console.log("run update title");
      if(id === '_field_elementary-school-name'){//elementary
        setTitle(pageTitle[0]);
      }else if(id === '_field_middle-school-name'){//middle
        setTitle(pageTitle[1]);
      }else{//secondary
        setTitle(pageTitle[2]);
      }
    }
    async function loadPosts() {
      
      if (catid !== undefined) {
        setPostType(catid);
        getCategoryName(catid);
      }else{
        setPostType('_field_school-name');
        getCategoryName('_field_school-name');
      }

      console.log(posttype);
      console.log("catid: " + catid);
      console.log('Page: '+page);
      

      /***************FRANKENSTEIN'S MONSTER*************************/
      await get("cred")
      .then(function (finalResult) { //get the user data to authenticate the user
          console.log("running...");
          setShowLoading(true);
          const userD = JSON.parse(finalResult);
          console.log(userD.userid);
          //axios.get('https://expmindapp.wpengine.com/wp-json/mind/v2/show/?id=' + userD.userid + '&key=' + posttype + '&paged=' + page,  {
          axios.get('https://explorermindsetapp.com/wp-json/mind/v2/show/?id=' + userD.userid + '&key=' + posttype + '&paged=' + page,  {
              headers: {
                  'Authentication': 'Bearer ' + userD.authtoken
              },
              timeout: 8000
          })
              .then(function (serverResponse) {
                  console.log(serverResponse);
                  console.log("response" + userD.userid);
                  const posts = serverResponse.data;
                  
                  const headerData = serverResponse;
                  const totalPages = headerData.headers['x-wp-totalpages'];
                  //const total = headerData.headers['x-wp-total'];
                  
                  setPosts(posts);
                  setTotPages(Number(totalPages));
                  //setTotal(Number(total));
                  setShowLoading(false);
              })
              .catch(function (error) {
                  if (error.response) {
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);
                  } else if (error.request) {
                      console.log(error.request)
                  } else {
                      console.log('Error', error.message);
                  }
                  console.log(error.config);
                  setShowLoading(false);
              });
      }).catch(err => {//unable to load the local storage
          console.log("e: " + err.message);
      }
      );
      /***************FRANKENSTEIN'S MONSTER*************************/
    }
    // call loadPosts when component PostsContainer renders
    loadPosts();
  }, [page, catid, posttype]);

  function handleClickNextPage(newPage: number) {
    console.log("pagenow" + newPage);
    setPage(newPage);//this should cause a rerender?
  }
  function handleNextbutton(newPage: any){
    //lets test some logic here. 
    
    setPage(newPage['page']+1);
    console.log(newPage['page'] + "" + totPages);
  }
  function handlePrevbutton(newPage: any){
    //lets test some logic here. 
    
    setPage(newPage['page']-1);
    console.log(newPage['page'] + "" + totPages);
  }
  function loadGroup(newPage:number, groupName:string){
    //loader
    setPage(newPage);
    //history.replace("/viewmindset/" + groupName);
    history.replace("/viewmindset/" + groupName);
    
    
  }
  function logOut(){
    console.log("logout");
    remove('cred');
    history.push('/home');
  }
  return (
    <IonPage>
      <LoginCheck/>
      <IonHeader translucent={true} >
        <IonToolbar>
        <IonButton size="small" slot="start" color="primary" onClick={() => history.push("/mindset/")} class="back"><IonIcon slot="start" icon={chevronBackOutline}/>Back</IonButton>
        <IonButton size="small" slot="end" color="primary" onClick={() => logOut()}  class="logout"><IonIcon slot="start" icon={logOutOutline}/>Log Out</IonButton>
        </IonToolbar>
      </IonHeader>
      <IonContent>
      <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => setShowLoading(false)}
          message={'Please wait...'}
          spinner={'bubbles'}
          duration={9000}
      />
     <IonText className="plantext innertext">
      <span>[</span>  <h3>View</h3> <span>]</span><h5>Mindsets</h5></IonText>
        <IonText class="padded">
        <h3>{title}</h3>
          <p> Below is a list of your saved files. To use one of your saved Mindsets to plan an exploration, select the "Create a MindMap" button. When you finish the form, your MindMap will be saved under "Saved MindMaps" below. Click on the file name to view or download your work.
     </p>
      </IonText>
      <IonToolbar color="primary">
            <IonSegment value={posttype}>
              <IonSegmentButton value="_field_school-name" onClick={()=>loadGroup(0,"_field_school-name")}>
                <IonLabel>Secondary</IonLabel>
              </IonSegmentButton>
              <IonSegmentButton value="_field_middle-school-name" onClick={()=>loadGroup(0,"_field_middle-school-name")}>
                <IonLabel>Middle</IonLabel>
              </IonSegmentButton>
              <IonSegmentButton value="_field_elementary-school-name" onClick={()=>loadGroup(0,"_field_elementary-school-name")}>
  <IonLabel>Elementary</IonLabel>
              </IonSegmentButton>
            </IonSegment>
        </IonToolbar>
        
        <Posts
          listOfPosts={posts}
          totPages={totPages}
          thePage={page}
          handleClickNextPage={handleClickNextPage}
        />
        <IonGrid>
        <IonButton href={'/createmindset'}>Create a Mindset</IonButton>
        <IonButton href={'/createmindmap'}>Create a Mind Map</IonButton>
        

          <IonRow>
            <IonCol>
            <IonButton 
          style={page !== 0 ? {} : { display: "none" }}
          expand="block"
          fill="outline"
          onClick={()=> handlePrevbutton({page})}>
            Previous
          </IonButton>
            </IonCol>
            <IonCol>
            <IonButton 
          style={page < (totPages-1) ? {} : { display: "none" }}
          expand="block"
          fill="outline"
          onClick={()=> handleNextbutton({page})}>
            Next
          </IonButton>
            </IonCol>
          </IonRow>
        </IonGrid>
        
      </IonContent>
      <FooterComponent/>
    </IonPage>
  );
}
